<template>
  <div>
    <div class="row q-mb-sm q-mt-lg">
      <div class="text-bold">
        Initial Values
      </div>
    </div>
    <div class="row q-col-gutter-md q-mb-md">
      <q-select
        class="col-6"
        label="Filter Types"
        :options="$mh.asOptions(EXPLORE_MOVIES_FILTER_TYPES.ALL)"
        map-options
        emit-value
        clearable
        multiple
        use-chips
        :model-value="exploreMoviesFilterTypes"
        @update:model-value="value => updateExploreMoviesFilterTypes(value)"
      />
    </div>
    <div
      class="row q-mb-md"
    >
      <q-tabs
        v-if="$q.screen.gt.xs"
        v-model="section.config.exploreType"
        dense
        no-caps
        style="border: 1px solid #ccc"
        class="q-pa-xs size-md q-mr-sm"
        active-color="white"
        active-bg-color="primary"
        indicator-color="transparent"
        align="justify"
        @update:model-value="changeCount++"
      >
        <q-tab
          v-if="section.config.exploreMoviesFilterTypes[EXPLORE_MOVIES_FILTER_TYPES.NOW_PLAYING]"
          :key="EXPLORE_MOVIES_FILTER_TYPES.NOW_PLAYING"
          :name="MOVIE_QUERY_TYPE.NOW_PLAYING"
          :label="$t('movie.nowPlaying')"
        />

        <q-tab
          v-if="section.config.exploreMoviesFilterTypes[EXPLORE_MOVIES_FILTER_TYPES.COMING_SOON]"
          :key="EXPLORE_MOVIES_FILTER_TYPES.COMING_SOON"
          :name="MOVIE_QUERY_TYPE.COMING_SOON"
          :label="$t('movie.comingSoon')"
        />
        <q-tab
          v-if="section.config.exploreMoviesFilterTypes[EXPLORE_MOVIES_FILTER_TYPES.ALL_MOVIES]"
          :key="EXPLORE_MOVIES_FILTER_TYPES.ALL_MOVIES"
          :name="MOVIE_QUERY_TYPE.NOW_PLAYING_AND_COMING_SOON"
          :label="$t('collection.all')"
        />
        <q-tab
          v-if="section.config.exploreMoviesFilterTypes[EXPLORE_MOVIES_FILTER_TYPES.MY_MOVIES]"
          :key="EXPLORE_MOVIES_FILTER_TYPES.MY_MOVIES"
          :name="MOVIE_QUERY_TYPE.MY_LISTS"
          :label="$t('movie.myMovies')"
        />
      </q-tabs>
      <q-select
        v-else
        v-model="section.config.exploreType"
        no-caps
        :options="[{ label: $t('movie.nowPlaying'), value: MOVIE_QUERY_TYPE.NOW_PLAYING },
                   { label: $t('movie.comingSoon'), value: MOVIE_QUERY_TYPE.COMING_SOON },
                   { label: $t('collection.all'), value: MOVIE_QUERY_TYPE.NOW_PLAYING_AND_COMING_SOON },
                   { label: 'My Movies', value: MOVIE_QUERY_TYPE.MY_LISTS }]"
        class="col-5"
        filled
        bg-color="transparent"
        map-options
        emit-value
        @update:model-value="changeCount++"
      />

      <q-tabs
        v-if="section.config.exploreType === MOVIE_QUERY_TYPE.MY_LISTS"
        v-model="section.config.exploreUserList"
        dense
        no-caps
        mobile-arrows
        inline-label
        class="text-secondary"
        active-color="white"
        active-bg-color="primary"
        indicator-color="transparent"
        align="left"
        @update:model-value="changeCount++"
      >
        <q-tab
          :key="'All'"
          :name="'all'"
          :label="$t('collection.all')"
          style="border: 1px solid;"
          class="q-mr-xs"
        />
        <q-tab
          :key="'Watched'"
          :name="'watched'"
          :label="'Watched'"
          icon="visibility"
          style="border: 1px solid;"
          class="q-mr-xs"
        />
        <q-tab
          :key="'watch-list'"
          :name="'watch_list'"
          :label="'Watch-list'"
          icon="bookmark"
          style="border: 1px solid;"
          class="q-mr-xs"
        />
        <q-tab
          :key="'Favorited'"
          :name="'favorite'"
          :label="'Favorited'"
          icon="ion-heart"
          style="border: 1px solid;"
          class="q-mr-xs"
        />
        <q-tab
          :key="'Rated'"
          :name="'rating'"
          :label="'Rated'"
          icon="star"
          style="border: 1px solid;"
          class="q-mr-xs"
        />
      </q-tabs>
      <model-form-select
        :model="section"
        field="config.exploreDisplayType"
        value-type="String"
        label="Initial View"
        :options="[{ label: 'Posters', value: 'posters' },
                   { label: 'Release Date', value: 'calendar' },
                   { label: 'Showings Calendar', value: 'showings-calendar' },
                   { label: 'Alphabetical', value: 'alphabetical' }]"
        popup-content-class="text-capitalize"
        class="col-auto text-capitalize"
        filled
        bg-color="transparent"
        map-options
        emit-value
        style="min-width: 150px"
        @update:model-value="changeCount++"
      />
      <q-btn
        v-if="section.config.exploreDisplayType === 'calendar'"
        icon="swap_vert"
        color="transparent"
        unelevated
        text-color="grey"
        size="sm"
        padding="sm"
        @update:model-value="changeCount++"
      />
    </div>
    <div class="row q-mb-sm q-mt-lg">
      <div class="text-bold">
        Filter Display
      </div>
    </div>
    <div class="row q-col-gutter-md q-mb-md">
      <model-form-input
        ref="search"
        :model="section"
        field="config.exploreFilterValue"
        value-type="String"
        label="Filter by Title, genre, actor, date ..."
        dense
        outlined
        clearable
        :style="{ width: $q.screen.lt.sm ? '150px' : undefined }"
        class="col-6 col-sm-3"
      />
      <model-form-select
        :model="section"
        field="exploreTitleClassIds"
        label="Title Classes"
        dense
        outlined
        map-options
        :options="titleClasses.data"
        clearable
        option-label="name"
        option-value="id"
        emit-value
        :style="{ width: $q.screen.lt.sm ? '150px' : undefined }"
        class="col-6 col-sm-3"
        multiple
        use-chips
      />
    </div>
    <div class="row q-mb-sm q-mt-lg">
      <div class="text-bold">
        Featured Movies
      </div>
    </div>
    <div class="row q-col-gutter-md q-mb-md">
      <model-form-select
        :model="section"
        field="exploreFeaturedTitleClassIds"
        label="Featured Title Classes"
        outlined
        map-options
        :options="exploreFeaturedTitleClassOptions"
        clearable
        option-label="name"
        option-value="id"
        emit-value
        :style="{ width: $q.screen.lt.sm ? '150px' : undefined }"
        class="col-6 col-sm-3"
        multiple
        use-chips
      />
      <showing-badge-select
        :model="section"
        label="Featured Showing Badges"
        field-name="exploreFeaturedShowingBadgeIds"
        class="col-6"
        dense
      />
    </div>
    <div class="row q-mb-sm q-mt-lg">
      <div class="text-bold">
        Control Visibility
      </div>
    </div>
    <div class="row q-col-gutter-md q-mb-md">
      <model-form-checkbox
        :model="section"
        field="config.showExploreHeading"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Show Heading"
      />
      <model-form-checkbox
        :model="section"
        field="config.showExploreType"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Show Type Control"
      />
      <model-form-checkbox
        :model="section"
        field="config.showExploreDisplayType"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Show Display Type"
      />
      <model-form-checkbox
        :model="section"
        field="config.showExploreSearch"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Show Search"
      />
      <model-form-checkbox
        :model="section"
        field="config.useClassFilter"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Show Class Filter"
      >
        <q-tooltip>
          If showing results are limited to specific title classes, those title classes will be used for the filter. If not, the filter will be based on the title classes from all showing results.
        </q-tooltip>
      </model-form-checkbox>

      <model-form-checkbox
        :model="section"
        field="config.exploreUsingDarkMode"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Dark Mode"
        :disable="$q.dark.isActive"
      >
        <q-tooltip v-if="$q.dark.isActive">
          Widget Dark Mode is disabled because the site-wide Dark Mode is enabled.
        </q-tooltip>
      </model-form-checkbox>
    </div>
    <div
      class="row q-mb-sm q-mt-sm"
    >
      <div class="text-bold">
        Row Settings
      </div>
    </div>
    <div
      class="row q-col-gutter-md q-mb-sm"
    >
      <q-checkbox
        v-model="configureExplorePosterMaxPerRow"
        class="col-6 col-sm-3"
        label="Customised Maximum Posters Per Row"
        bottom-slots
      />
      <template v-if="configureExplorePosterMaxPerRow">
        <div
          class="col-6 col-sm-3"
        >
          <q-item-label>Maximum Posters Per Row</q-item-label>
          <q-slider
            v-model="section.config.explorePosterMaximumPostersPerRow"
            label
            label-always
            switch-label-side
            type="number"
            :min="0"
            :max="10"
            :step="1"
            @update:model-value="changeCount++"
          />
        </div>
        <q-checkbox
          v-model="configureExplorePosterMobileMaxPerRow"
          class="col-6 col-sm-3"
          label="Set Different Maximum Poster Per Row on Mobile"
          bottom-slots
        />
        <div
          v-if="configureExplorePosterMobileMaxPerRow"
          class="col-6 col-sm-3"
        >
          <q-item-label>Mobile Maximum Posters Per Row</q-item-label>
          <q-slider
            v-model="section.config.explorePosterMobileMaximumPostersPerRow"
            label
            label-always
            switch-label-side
            type="number"
            :min="0"
            :max="10"
            :step="1"
            @update:model-value="changeCount++"
          />
        </div>
      </template>
      <div
        class="col-6 col-sm-3"
      >
        <q-item-label>Poster Padding</q-item-label>
        <q-slider
          v-model="section.config.explorePosterPadding"
          label
          label-always
          switch-label-side
          type="number"
          :min="0"
          :max="28"
          :step="4"
        />
      </div>
    </div>
    <div class="row q-mb-sm q-mt-sm">
      <div class="text-bold">
        Poster Settings
      </div>
    </div>
    <div class="row q-col-gutter-md q-mb-sm">
      <model-form-checkbox
        v-if="!section.hasFeatures"
        :model="section"
        field="config.useBanner"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Use Banner Image"
      />

      <model-form-checkbox
        :model="section"
        field="config.explorePosterShowUserButtons"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Show User Buttons"
      />
      <model-form-checkbox
        :model="section"
        field="config.explorePosterShowTrailerButton"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Show Trailer Button"
      />
      <model-form-checkbox
        :model="section"
        field="config.explorePosterShowMovieTitle"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Show Movie Title"
      />
      <model-form-checkbox
        :model="section"
        field="config.explorePosterShowMovieRating"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Show Movie Rating"
      />
      <model-form-checkbox
        :model="section"
        field="config.explorePosterShowMovieGenre"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Show Movie Genre"
      />
      <model-form-checkbox
        :model="section"
        field="config.explorePosterShowMovieSynopsis"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Show Movie Synopsis"
      />

      <model-form-checkbox
        :model="section"
        field="config.explorePosterShowMovieShowingStatus"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Show Movie Showing Status"
      />

      <model-form-checkbox
        v-if="section.config.exploreType !== MOVIE_QUERY_TYPE.NOW_PLAYING || !!section.config.showExploreType"
        :model="section"
        field="config.showComingSoonDate"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Show Coming Soon Date"
      />

      <model-form-checkbox
        field="config.exploreMovieShowTitleClass"
        :model="section"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Show Movie Class"
      />
      <q-checkbox
        v-model="showButton"
        class="col-6 col-sm-3"
        label="Show button"
        bottom-slots
      />
      <model-form-checkbox
        v-if="showCleanImageSetting"
        :model="section"
        field="config.explorePosterHasCleanImage"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Clean Image"
      />
      <div
        class="col-6 col-sm-3"
      >
        <q-item-label>Border Radius</q-item-label>
        <q-slider
          v-model="section.config.explorePosterBorderRadius"
          label
          label-always
          switch-label-side
          type="number"
          :min="0"
          :max="32"
          :step="4"
        />
      </div>
      <div
        class="col-6 col-sm-3"
      >
        <q-item-label>Shadow</q-item-label>
        <q-slider
          v-model="section.config.shadow"
          label
          label-always
          switch-label-side
          type="number"
          :min="0"
          :max="10"
          :step="1"
        />
      </div>
      <color-selection
        class="col-12 col-sm-6"
        :color-name="section.config.explorePosterBackgroundColor"
        :custom-color-hex="section.config.explorePosterBackgroundColorHex"
        label="Background Color"
        @update:model-value="setBackgroundColor"
      />
      <q-checkbox
        v-if="section.hasFeatures"
        v-model="configureExplorePosterFeaturedBackgroundColor"
        class="col-6 col-sm-3"
        label="Set Different Color For Featured Poster"
        bottom-slots
      />
      <color-selection
        v-if="section.hasFeatures && configureExplorePosterFeaturedBackgroundColor"
        class="col-12 col-sm-6"
        :color-name="section.config.explorePosterFeaturedBackgroundColor"
        :custom-color-hex="section.config.explorePosterFeaturedBackgroundColorHex"
        label="Featured Movie Background Color"
        @update:model-value="setFeaturedBackgroundColor"
      />
    </div>
    <div
      v-if="showTextSettings"
      class="row q-mb-sm q-mt-sm"
    >
      <div class="text-bold">
        Text Settings
      </div>
    </div>
    <div
      v-if="showTextSettings"
      class="row q-col-gutter-md"
    >
      <model-form-input
        :model="section"
        field="config.explorePosterFontSize"
        value-type="Number"
        label="Font size"
        type="number"
        suffix="px"
        dense
        outlined
        clearable
        class="col-6 col-sm-3"
      />
      <model-form-checkbox
        v-if="section.config.explorePosterShowMovieTitle || section.config.explorePosterShowMovieRating || section.config.explorePosterShowMovieGenre"
        :model="section"
        field="config.explorePosterShouldWrapText"
        value-type="Boolean"
        class="col-6 col-sm-2"
        :label="wrapTextLabel"
      >
        <q-tooltip>Wrap the Movie Title or Movie Genre to One Line</q-tooltip>
      </model-form-checkbox>
      <model-form-checkbox
        v-if="section.config.explorePosterShowMovieSynopsis"
        :model="section"
        field="config.explorePosterMovieSynopsisTruncated"
        value-type="Boolean"
        class="col-6 col-sm-3"
        label="Truncate Movie Synopsis"
      />

      <div
        v-if="section.config.explorePosterShowMovieSynopsis && section.config.explorePosterMovieSynopsisTruncated"
        class="col-6 col-sm-3"
      >
        <q-item-label>Maximum Mobile Truncated Synopsis Line Count</q-item-label>
        <q-slider
          v-model="section.config.mobileTruncatedLineCount"
          label
          label-always
          switch-label-side
          type="number"
          :min="3"
          :max="21"
          :step="3"
        />
      </div>
      <div
        v-if="section.config.explorePosterShowMovieSynopsis && section.config.explorePosterMovieSynopsisTruncated"
        class="col-6 col-sm-3"
      >
        <q-item-label>Maximum Truncated Movie Synopsis Lines Count</q-item-label>
        <q-slider
          v-model="section.config.truncatedLineCount"
          label
          label-always
          switch-label-side
          type="number"
          :min="3"
          :max="21"
          :step="3"
        />
      </div>
      <model-form-checkbox
        field="config.explorePosterHasTextCentred"
        :model="section"
        value-type="Boolean"
        class="col-6 col-sm-2"
        label="Centred Text"
      />
    </div>
    <div
      v-if="showButton"
      class="row q-mb-sm q-mt-sm"
    >
      <div class="text-bold">
        Button Settings
      </div>
    </div>
    <div
      v-if="showButton"
      class="row q-col-gutter-md q-mb-xl"
    >
      <model-form-input
        field="config.explorePosterButtonLabel"
        value-type="String"
        label="Button Label"
        class="col-6 col-sm-3"
        :rules="[val => val !== null || 'Field is required']"
      />
      <model-form-select
        field="config.explorePosterButtonType"
        value-type="String"
        class="col-3"
        :options="buttonTypeOptions"
        map-options
        emit-value
        clearable
        label="Button Type"
      />
      <color-selection
        class="col-12 col-sm-6"
        :color-name="section.config.explorePosterButtonColor"
        :custom-color-hex="section.config.explorePosterButtonColorHex"
        label="Button Color"
        @update:model-value="setButtonColor"
      />
      <div
        v-if="section.config.explorePosterButtonType !== 'flat'"
        class="col-6 col-sm-3"
      >
        <q-item-label>Border Radius</q-item-label>
        <q-slider
          v-model="section.config.explorePosterButtonBorderRadius"
          label
          label-always
          switch-label-side
          type="number"
          :min="0"
          :max="32"
          :step="4"
        />
      </div>
    </div>
    <preview
      v-if="!hidePreview"
      :key="changeCount"
      :section="section"
      class="q-mb-xl"
    />
  </div>
</template>

<script>

import { MOVIE_QUERY_TYPE } from 'src/models/movie/Movie'
import Section, { BUTTON_TYPES, EXPLORE_MOVIES_FILTER_TYPES } from 'src/models/page/Section'
import ColorSelection from 'src/modules/admin/components/ColorSelection'
import ShowingBadgeSelect from 'src/modules/admin/showing-badge/components/ShowingBadgeSelect'
import Preview from 'src/modules/consumer/components/Preview'

export default {
  name: 'ExploreMoviesEditor',
  components: {
    ShowingBadgeSelect,
    Preview,
    ColorSelection
  },
  props: {
    section: {
      type: Section,
      required: true
    },
    hidePreview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      changeCount: 0,
      configureExplorePosterMaxPerRow: !!this.section.config.explorePosterMaximumPostersPerRow && this.section.config.explorePosterMaximumPostersPerRow !== 8,
      configureExplorePosterMobileMaxPerRow: !!this.section.config.explorePosterMobileMaximumPostersPerRow && this.section.config.explorePosterMobileMaximumPostersPerRow !== 3,
      showButton: this.section.config.explorePosterButtonLabel !== null,
      configureExplorePosterFeaturedBackgroundColor: this.section.config.explorePosterFeaturedBackgroundColor !== null
    }
  },
  computed: {
    showTextSettings () {
      return this.section.config.explorePosterShowMovieTitle || this.section.config.explorePosterShowMovieRating || this.section.config.explorePosterShowMovieGenre || this.section.config.explorePosterShowMovieSynopsis || this.showButton
    },
    showCleanImageSetting () {
      return this.section.config.explorePosterShowMovieTitle || this.section.config.explorePosterShowMovieRating || this.section.config.explorePosterShowMovieGenre || this.section.config.explorePosterShowMovieShowingStatus || this.section.config.exploreMovieShowTitleClass
    },
    wrapTextLabel () {
      return 'Truncated Movie ' +
          (this.section.config.explorePosterShowMovieTitle ? 'Title' : '') +
          (this.section.config.explorePosterShowMovieTitle && (this.section.config.explorePosterShowMovieRating || this.section.config.explorePosterShowMovieGenre) ? ' and ' : '') +
          (this.section.config.explorePosterShowMovieRating || this.section.config.explorePosterShowMovieGenre ? 'Genre' : '')
    },
    exploreMoviesFilterTypes () {
      return this.$mh.objectToArray({ ...this.section.config.exploreMoviesFilterTypes })
    },
    exploreFeaturedTitleClassOptions () {
      if (_.isEmpty(this.section.exploreTitleClassIds)) return this.titleClasses.data

      return _.filter(this.titleClasses.data, titleClass => _.some(this.section.exploreTitleClassIds, id => id === titleClass.id))
    }
  },
  watch: {
    configureExplorePosterMaxPerRow () {
      if (!this.configureExplorePosterMaxPerRow) { this.section.config.explorePosterMaximumPostersPerRow = 8 }
    },
    configureExplorePosterMobileMaxPerRow () {
      if (!this.configureExplorePosterMobileMaxPerRow) { this.section.config.explorePosterMobileMaximumPostersPerRow = 3 }
    },
    configureExplorePosterFeaturedBackgroundColor () {
      if (!this.configureExplorePosterFeaturedBackgroundColor || !this.section.hasFeatures) {
        this.section.config.explorePosterFeaturedBackgroundColor = null
      }
    },
    showButton () {
      if (!this.showButton) {
        this.section.config.explorePosterButtonLabel = null
      }
    },
    'section.config.explorePosterButtonLabel': function () {
      if (this.section.config.explorePosterButtonLabel !== null) {
        this.showButton = true
      }
    },
    '$q.dark.isActive': {
      handler () {
        if (this.$q.dark.isActive) {
          this.section.config.exploreUsingDarkMode = true
        }
      },
      immediate: true
    }
  },
  created () {
    _.extend(this, { buttonTypeOptions: this.$mh.asOptions(BUTTON_TYPES), BUTTON_TYPES }, { EXPLORE_MOVIES_FILTER_TYPES, MOVIE_QUERY_TYPE })
  },
  configuration: ['titleClasses'],
  methods: {
    setBackgroundColor (colorName, customColorHex) {
      this.section.config.explorePosterBackgroundColor = colorName
      this.section.config.explorePosterBackgroundColorHex = customColorHex
    },
    setFeaturedBackgroundColor (colorName, customColorHex) {
      this.section.config.explorePosterFeaturedBackgroundColor = colorName
      this.section.config.explorePosterFeaturedBackgroundColorHex = customColorHex
    },
    setButtonColor (colorName, customColorHex) {
      this.section.config.explorePosterButtonColor = colorName
      this.section.config.explorePosterButtonColorHex = customColorHex
    },
    updateExploreMoviesFilterTypes (value) {
      this.section.config.exploreMoviesFilterTypes = this.$mh.arrayToObject(value || [], EXPLORE_MOVIES_FILTER_TYPES.ALL)
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
